<template>
  <div class="summary-schedule" data-testid="task-summary-schedule">
    <div class="summary-schedule__header">Schedule</div>
    <div class="summary-schedule__body pa-4">
      <div class="d-flex justify-space-between align-start">
        <div class="d-flex flex-column gap-1" data-testid="task-summary-schedule__due-date">
          <p class="summary-schedule__section-label summary-schedule__section-label-due-date">Due Date</p>
          <p class="summary-schedule__due-day">{{ dueDayMonth }}</p>
          <p class="summary-schedule__due-meta">{{ dueMeta }}</p>
        </div>
        <div v-if="task.priority" data-testid="task-summary-schedule__priority">
          <p class="summary-schedule__section-label">Priority</p>
          <TaskPriorityDisplay
            variant="cell"
            :priority="task.priority"
            data-testid="task-summary-schedule__priority-value"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaskPriorityDisplay from '../../../TaskList/components/TaskPriorityDisplay/TaskPriorityDisplay.vue';
import './TaskSummarySchedule.scss';

export default {
  name: 'TaskSummarySchedule',

  components: {
    TaskPriorityDisplay,
  },

  props: {
    task: { type: Object, required: true },
  },

  computed: {
    dueDayMonth() {
      if (!this.task.duedate) return '—';
      return this.$nova.formatDateTime(this.task.duedate, 'DD MMM');
    },
    dueMeta() {
      if (!this.task.duedate) return '';
      const year = this.$nova.formatDateTime(this.task.duedate, 'YYYY');
      const daysLabel = this.daysRemainingLabel;
      return daysLabel ? `${year} · ${daysLabel}` : year;
    },
    daysRemainingLabel() {
      if (this.task.duedays == null) return '';
      if (this.task.duedays < 0) return `${Math.abs(this.task.duedays)} days overdue`;
      if (this.task.duedays === 0) return 'due today';
      return `${this.task.duedays} days remaining`;
    },
  },
};
</script>
